import { render } from "./entityCardsSetUp.vue?vue&type=template&id=892f4628"
import script from "./entityCardsSetUp.vue?vue&type=script&lang=js"
export * from "./entityCardsSetUp.vue?vue&type=script&lang=js"

import "./entityCardsSetUp.vue?vue&type=style&index=0&id=892f4628&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__